import EmblaCarousel from 'embla-carousel';

const TestimonialSlider = (parentNode) => {
  const viewport = parentNode.querySelector('.gp-testimonial-slider');
  if (!viewport) return;

  const embla = EmblaCarousel(viewport, {
    loop: false,
    align: 'start',
    containScroll: 'trimSnaps',
    dragFree: false,
  });

  const prev = parentNode.querySelector('.slider-prev');
  const next = parentNode.querySelector('.slider-next');

  const updateButtons = () => {
    if (prev) prev.disabled = !embla.canScrollPrev();
    if (next) next.disabled = !embla.canScrollNext();
  };

  prev?.addEventListener('click', (e) => {
    e.preventDefault();
    embla.scrollPrev();
  });
  next?.addEventListener('click', (e) => {
    e.preventDefault();
    embla.scrollNext();
  });

  embla.on('select', updateButtons);
  embla.on('reInit', updateButtons);
  updateButtons();
};

export default TestimonialSlider;
